<template>
  <div class="checkbox">
    <input
      :id="value"
      v-model="internalValue"
      :name="name"
      :value="value"
      type="checkbox"
    >
    <label :for="value">{{ label }}</label>
  </div>
</template>

<script lang="ts" setup>
import type { InputHTMLAttributes } from 'vue';
import { useVModel } from '@vueuse/core';

interface Props {
  name?: string;
  label?: string;
  value: string;
  modelValue?: InputHTMLAttributes['checked'];
}

const emit = defineEmits(['update:modelValue']);
const props = defineProps<Props>();
const internalValue = useVModel(props, 'modelValue', emit, { passive: true });
</script>

<style lang="scss" scoped>
input {
  display: none;
}

.checkbox {
  @apply w-fit cursor-pointer;

  label {
    @apply pl-7;
    @apply cursor-pointer;

    @include absolutePseudo('before') {
      @apply left-0 top-1/2 -translate-y-1/2;
      @apply w-4.5 h-4.5;
      @apply bg-white;
      @apply border border-checkbox-gray rounded-4;
    }
  }

  input:checked + label {
    &::before {
      @apply bg-info-blue;
    }
  }
}
</style>
